import SourceAccount from "../class/sourceAccount";

const currentYear = new Date().getFullYear();

const connectOldAccountValidations = {
  sponsorName: (oldAccountDetails: Partial<SourceAccount>) => {
    if (!oldAccountDetails.planSponsor) {
      return "Please tell us your old employer name";
    } else {
      return "";
    }
  },
  startYear: (oldAccountDetails: Partial<SourceAccount>) => {
    if (!oldAccountDetails.startYear) {
      return "Please enter your start year";
    }
    const startYearNumber = parseInt(oldAccountDetails?.startYear) || 0;
    const endYearNumber = oldAccountDetails?.terminatedYear ? parseInt(oldAccountDetails?.terminatedYear) : 0;
    if (startYearNumber < 999 && !endYearNumber) {
      return "";
    }

    if (startYearNumber < currentYear - 100) {
      return "Please enter a validate year";
    }

    if (startYearNumber > 999 && startYearNumber > currentYear) {
      return `Your start year cannot be greater than ${currentYear}`;
    }
    if (endYearNumber > 999 && startYearNumber > endYearNumber) {
      return `Your start year cannot be greater than ${endYearNumber}`;
    }
    return "";
  },
  endYear: (oldAccountDetails: Partial<SourceAccount>) => {
    if (!oldAccountDetails.terminatedYear) {
      return "Please enter your end year";
    }
    const startYearNumber = oldAccountDetails.startYear ? parseInt(oldAccountDetails.startYear) : 0;
    const endYearNumber = parseInt(oldAccountDetails.terminatedYear) || 0;
    if (endYearNumber < 999) {
      return "";
    }

    if (endYearNumber < currentYear - 100) {
      return "Please enter a validate year";
    }
    if (endYearNumber > 999 && endYearNumber > currentYear) {
      return `Your end year cannot be greater than ${currentYear}`;
    }
    if (endYearNumber > 999 && startYearNumber > endYearNumber) {
      return `Your end year cannot be smaller than ${startYearNumber}`;
    }
    return "";
  },
  accountStatement: (oldAccountDetails: Partial<SourceAccount>) => {
    if (!oldAccountDetails.statementSkipped && oldAccountDetails?.sourceStatementFileNames?.length === 0) {
      return "Please upload your account statement";
    }
    return "";
  },
  validateField: (key: keyof SourceAccount, oldAccountDetails: Partial<SourceAccount>) => {
    switch (key) {
      case "planSponsor":
        return connectOldAccountValidations.sponsorName(oldAccountDetails);
      case "startYear":
        return connectOldAccountValidations.startYear(oldAccountDetails);
      case "terminatedYear":
        return connectOldAccountValidations.endYear(oldAccountDetails);
      case "statementSkipped":
        return connectOldAccountValidations.accountStatement(oldAccountDetails);
      default:
        return "";
    }
  },
};

export default connectOldAccountValidations;
